export default "__VITE_ASSET__DHUWuG7l__"